import { initContract } from '@ts-rest/core';
import { adminSubscriptionContract } from './subscription.admin.contract';
import { authSubscriptionContract } from './subscription.auth.contract';

const c = initContract();

export const subscriptionContract = c.router(
  {
    admin: adminSubscriptionContract,
    auth: authSubscriptionContract,
  },
  {
    pathPrefix: '/subscription',
    strictStatusCodes: true,
  }
);

export * from './models';
export * from './subscription.admin.contract';
export * from './subscription.auth.contract';

